import React, {Component} from 'react';
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";


class AlertStatusCellRender extends Component {
  
  renderSwitch(param) {
    let returnClass='';
    switch(param) {
      case 'Pending':
        returnClass='primary';break;
      case 'Inprogress':
        returnClass='warning';break;      
      case 'Fail':
        returnClass='danger';break;      
      case 'Success':
        returnClass='success';break;              
      default:
        returnClass='secondary';break;  
    }
    return <span className={"badge bg-"+returnClass}> {param}</span>
  }

  render() {
    return (
      this.renderSwitch(this.props.value)
    )
  }
}

AlertStatusCellRender.propTypes = {
  value: PropTypes.any,
  t: PropTypes.any,
};

export default (withTranslation()(AlertStatusCellRender));